module.exports = __webpack_public_path__ + "img/gongsi.64bead89.jpg";